import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class PasswordReset extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('passwordResetForm.onOpen', (event) => {
      return this.onOpen(event);
    });
  }

  onOpen(event) {
    this.logger('Trying to restore a password');

    let form = event.origin.closest('form'),
        email = form.find('[type=email]').val();

    this.App.Form.Submitter.resetErrors(form);
    event.modal.find('form [type=email]').val(email).focus();

  }

}